var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      !_vm.flag ? _c("navComp") : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade-transform", mode: "out-in" } },
        [_vm.$store.getters.metaMaskObj.initOk ? _c("router-view") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _c("el-backtop", { attrs: { bottom: 100 } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }